import { useEffect, useState } from "react";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { Footer } from "../../../../layouts/footer";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";

export const StoreLocations = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ResponsiveAppBar />
      <div
        id="wrapper"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
        }}
      >
        <h3 className="fs-22 fw-6 text-center mt-5">
          Navya Bakeshop Locations
        </h3>
        <section className="flat-spacing-16 pt-4">
          <div className="container">
            <div className="row widget-tabs">
              <div className="col-xl-4 col-md-5 col-12">
                <div
                  className="tf-store-list d-flex gap-10 flex-column widget-menu-tab"
                  style={{ height: "500px", overflowY: "scroll" }}
                >
                  <div className="tf-store-item item-title default">
                    <h6 className="tf-store-title">
                      <div className="icon">
                        <i className="icon-place"></i>
                      </div>
                      Angamaly central Jn.
                    </h6>
                    <div className="tf-store-info">
                      <span>Address</span>
                      <p>
                        {" "}
                        Central Junction Angamaly Ernakulam, Kerala,
                        India-683572{" "}
                      </p>
                    </div>
                    <div className="tf-store-info">
                      <span>Phone</span>
                      <p>+91 9496001256</p>
                    </div>
                    <div className="tf-store-info">
                      <span>Email</span>
                      <p>ang1@navyabakers.com</p>
                    </div>
                  </div>
                  <div className="tf-store-item item-title default">
                    <h6 className="tf-store-title">
                      <div className="icon">
                        <i className="icon-place"></i>
                      </div>
                      Angamaly MC road
                    </h6>
                    <div className="tf-store-info">
                      <span>Address</span>
                      <p>
                        Xx/606a B, CVR Trade Centre, Mc Road Angamaly,
                        Ernakulam,Kerala, India-683572{" "}
                      </p>
                    </div>
                    <div className="tf-store-info">
                      <span>Phone</span>
                      <p>+91 9496001268</p>
                    </div>
                    <div className="tf-store-info">
                      <span>Email</span>
                      <p>ang2@navyabakers.com</p>
                    </div>
                  </div>
                  <div className="tf-store-item item-title default">
                    <h6 className="tf-store-title">
                      <div className="icon">
                        <i className="icon-place"></i>
                      </div>
                      Angamaly TB Jn.
                    </h6>
                    <div className="tf-store-info">
                      <span>Address</span>
                      <p>
                        {" "}
                        Vii/415 Golden Plaza, Tb Junction,
                        Angamaly,Ernakulam,Kerala,India-683572
                      </p>
                    </div>
                    <div className="tf-store-info">
                      <span>Phone</span>
                      <p>+91 9497713228</p>
                    </div>
                    <div className="tf-store-info">
                      <span>Email</span>
                      <p>ang3@navyabakers.com</p>
                    </div>
                  </div>
                  <div className="tf-store-item item-title default active">
                    <h6 className="tf-store-title">
                      <div className="icon">
                        <i className="icon-place"></i>
                      </div>
                      Athani
                    </h6>
                    <div className="tf-store-info">
                      <span>Address</span>
                      <p>
                        V/384b G Geojo Square, NH Road,Athani (Ernakulam),
                        Kerala,India-683585
                      </p>
                    </div>
                    <div className="tf-store-info">
                      <span>Phone</span>
                      <p>+91 9496001269</p>
                    </div>
                    <div className="tf-store-info">
                      <span>Email</span>
                      <p>athani@navyabakers.com</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-8 col-md-7 col-12">
                <div className="widget-content-tab">
                  <div className="widget-content-inner p-0">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d158969.55657176184!2d-0.176367!3d51.496715!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760542e6182f3f%3A0x7bb7e385c39764c4!2zQuG6o28gdMOgbmcgTOG7i2NoIHPhu60gVOG7sSBuaGnDqm4gTHXDom4gxJDDtG4!5e0!3m2!1svi!2sus!4v1719308620173!5m2!1svi!2sus"
                      width="100%"
                      height="978"
                      //   style="border:0;"
                      //   allowfullscreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                  <div className="widget-content-inner p-0">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d158969.55657176184!2d-0.176367!3d51.496715!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760542e6182f3f%3A0x7bb7e385c39764c4!2zQuG6o28gdMOgbmcgTOG7i2NoIHPhu60gVOG7sSBuaGnDqm4gTHXDom4gxJDDtG4!5e0!3m2!1svi!2sus!4v1719308885091!5m2!1svi!2sus"
                      width="100%"
                      height="978"
                      //   style="border:0;"
                      //   allowfullscreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                  <div className="widget-content-inner p-0">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d194388.1638384037!2d-3.717769!3d40.424022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd42286e8bea1259%3A0x1d6ad9c64a7706ab!2sTemple%20of%20Debod!5e0!3m2!1svi!2sus!4v1719308938883!5m2!1svi!2sus"
                      width="100%"
                      height="978"
                      //   style="border:0;"
                      //   allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                  <div className="widget-content-inner p-0 active">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d51856.75050320975!2d139.768121!3d35.675847!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x605d1b87f02e57e7%3A0x2e01618b22571b89!2zVMO0a3nDtCwgTmjhuq10IELhuqNu!5e0!3m2!1svi!2sus!4v1719308962873!5m2!1svi!2sus"
                      width="100%"
                      height="978"
                      //   style="border:0;"
                      //   allowfullscreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
          <span
            className="icon-close icon-close-popup"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></span>
          <div className="mb-canvas-content">
            <div className="mb-body">
              <ul className="nav-ul-mb" id="wrapper-menu-navigation">
                <li className="nav-mb-item">
                  <a href="#" className="item-link">
                    Navya Corporate
                  </a>
                </li>
                <li className="nav-mb-item">
                  <a href="#" className="item-link">
                    Offers
                  </a>
                </li>
                <li>
                  <a
                    href="#sub-shop-two"
                    className="sub-nav-link collapsed"
                    data-bs-toggle="collapse"
                    aria-expanded="true"
                    aria-controls="sub-shop-two"
                  >
                    <span>Products</span>
                    <span className="btn-open-sub"></span>
                  </a>
                  <div id="sub-shop-two" className="collapse">
                    <ul className="sub-nav-menu sub-menu-level-2">
                      <li>
                        <a href="#" className="sub-nav-link">
                          Product 1
                        </a>
                      </li>
                      <li>
                        <a href="#" className="sub-nav-link">
                          Product 2
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-mb-item">
                  <a href="#" className="item-link">
                    Help
                  </a>
                </li>
              </ul>
              <div className="mb-other-content">
                <div className="d-flex group-icon">
                  <a href="#" className="site-nav-icon">
                    <i className="icon icon-heart"></i>Wishlist
                  </a>
                  <a href="#" className="site-nav-icon">
                    <i className="icon icon-search"></i>Search
                  </a>
                </div>
                <div className="mb-notice">
                  <a href="#" className="text-need">
                    Need help ?
                  </a>
                </div>
                <ul className="mb-info">
                  <li>
                    Address: Central Junction Angamaly Ernakulam, Kerala,
                    India-683572{" "}
                  </li>
                  <li>
                    Email: <b>info@navyabakers.com</b>
                  </li>
                  <li>
                    Phone: <b>+91 9496001256</b>
                  </li>
                </ul>
              </div>
            </div>
            <div className="mb-bottom">
              <a href="#" className="site-nav-icon">
                <i className="icon icon-account"></i>Login
              </a>
              <div className="bottom-bar-language">
                <div className="tf-currencies">
                  <div className="dropdown bootstrap-select image-select center style-default type-currencies">
                    <select className="image-select center style-default type-currencies">
                      <option>Home: Manuvel villa, Ernakulam</option>
                      <option>Work: Infopark, Kochi</option>
                    </select>
                    <button
                      type="button"
                      //   tabIndex="-1"
                      className="btn dropdown-toggle btn-light"
                      data-bs-toggle="dropdown"
                      role="combobox"
                      aria-owns="bs-select-1"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                      title="Home: Manuvel villa, Ernakulam"
                    >
                      <div className="filter-option">
                        <div className="filter-option-inner">
                          <div className="filter-option-inner-inner">
                            Home: Manuvel villa, Ernakulam
                          </div>
                        </div>{" "}
                      </div>
                    </button>
                    <div className="dropdown-menu ">
                      <div
                        className="inner show"
                        role="listbox"
                        id="bs-select-1"
                        // tabIndex="-1"
                      >
                        <ul
                          className="dropdown-menu inner show"
                          role="presentation"
                        ></ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
